import linkifyStr from 'linkify-string';
import * as React from 'react';
import { Flex } from '../../designSystem/components/flex';
import {
    CustomBadgeVolunteerRegistrationFragment,
    CustomFieldWithConditionFragment,
    Event
} from '../../generated/types';
import { TemplateService } from '../../services/templateService';
import { useService } from '../../util/dependencies/dependencies';
import { DocumentTextElement } from '../../vo/documentBuilder';

interface IUserCustomDocumentTextProps {
    customFields: CustomFieldWithConditionFragment[];
    element: DocumentTextElement;
    event: Pick<Event, 'id' | 'organizationId' | 'name' | 'startAt' | 'endAt'>;
    vr: CustomBadgeVolunteerRegistrationFragment;
}

export const UserCustomDocumentText = (props: IUserCustomDocumentTextProps) => {
    const templateService = useService(TemplateService);
    const renderedText = linkifyStr(
        templateService.renderText(props.element.text, {
            userInfo: props.vr.userInfo,
            event: props.event,
            customFields: props.customFields,
            volunteerRegistration: props.vr
        }),
        { target: '_blank' }
    );

    return (
        <Flex
            align={props.element.align}
            css={{
                backgroundColor: props.element.hasBackground
                    ? props.element.backgroundColor
                    : 'none',
                border:
                    props.element.borderSize > 0
                        ? `${props.element.borderSize}px solid ${props.element.borderColor}`
                        : '',
                borderRadius:
                    props.element.borderRadius > 0 ? `${props.element.borderRadius}px` : '0',
                color: props.element.color,
                fontFamily: props.element.fontFamily,
                fontSize: `${props.element.fontSize}px`,
                fontWeight: props.element.fontWeight,
                left: `${props.element.left}px`,
                lineHeight: props.element.lineHeight || 1.4,
                overflow: 'hidden',
                paddingBottom: `${props.element.py || 0}px`,
                paddingLeft: `${props.element.px || 0}px`,
                paddingRight: `${props.element.px || 0}px`,
                paddingTop: `${props.element.py || 0}px`,
                position: props.element.inContainer ? 'static' : 'absolute',
                textAlign: props.element.justify,
                textTransform: props.element.textTransform,
                top: `${props.element.top}px`,
                transform: props.element.hasRotate
                    ? `rotate(${props.element.rotateDegree}deg)`
                    : undefined,
                transformOrigin: props.element.hasRotate ? 'top left' : undefined,
                whiteSpace: 'pre-wrap',
                zIndex: props.element.zIndex,
                '& a': {
                    color: 'inherit'
                }
            }}
            dangerouslySetInnerHTML={{
                __html: renderedText
            }}
            height={props.element.height}
            justify={props.element.justify}
            width={props.element.width}
        />
    );
};
